import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { FAQ } from "../../data/content";

export const Faq = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 bg-[color:var(--bg)]"
    >
      <div className="max-w-3xl mx-auto px-6 md:px-12 text-center">
        <div className="text-sm uppercase tracking-[0.22em] text-accent font-semibold">
          Tanya Jawab
        </div>
        <h2 className="font-serif-display text-primary text-4xl sm:text-5xl mt-4 leading-tight">
          Hal yang sering ditanyakan
        </h2>
        <p className="text-muted mt-5">
          Beberapa pertanyaan umum seputar layanan umroh dan haji Baba Tour.
        </p>
      </div>

      <div className="max-w-3xl mx-auto mt-14 px-6 md:px-12">
        <Accordion type="single" collapsible className="space-y-3">
          {FAQ.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-surface border border-soft rounded-2xl px-6 data-[state=open]:bg-surface"
            >
              <AccordionTrigger className="text-left font-serif-display text-lg md:text-xl text-primary hover:no-underline py-5">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted leading-relaxed pb-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
<div className="max-w-3xl mx-auto mt-12 px-6 md:px-12 text-center">
  <p className="text-muted">
    Masih memiliki pertanyaan? Tim kami siap membantu.
  </p>

  <div className="mt-6 flex flex-col sm:flex-row justify-center gap-3">
    <a
      href="https://wa.me/6282392156538"
      target="_blank"
      rel="noreferrer"
      className="bg-primary text-white rounded-full px-6 py-3 font-medium hover:bg-primary/90 transition"
    >
      WhatsApp Batam
    </a>

    <a
      href="https://wa.me/62811713309"
      target="_blank"
      rel="noreferrer"
      className="border border-soft text-primary rounded-full px-6 py-3 font-medium hover:bg-surface transition"
    >
      WhatsApp Palembang
    </a>
  </div>
</div>

    </section>
  );
};
